const Accordions = {
  baseStyle: {},
  variants: {
    standard: {
      allowMultiple: true,
      container: {
        border: "none",
        borderStyle: "none",
        color: "white",
        width: "14em",
      },
      button: {
        justifyContent: "center",
        pt: "2em",
        pb: "2em",
        as: "Link",
        bg: "Primary.800",
        color: "white",
        border: "none",
        borderRadius: "none",
        boxShadow: "none",
        width: "100%",
        _hover: {
          borderRadius: "none",
          bg: "Primary.900",
          textDecoration: "underline",
        },
        panel: {
          bg: "Primary.700",
        },
      },
    },
    dataSets: {
      allowMultiple: true,
      font: "body",
      root: {
        margin: "0",
      },
      container: {
        border: "none",
        borderStyle: "none",
        color: "white",
      },
      button: {
        paddingLeft: "1em",
        bg: "Primary.700",
        color: "white",
        border: "none",
        borderRadius: "none",
        boxShadow: "none",
        width: "100%",
        _hover: {
          bg: "Primary.800",
        },
      },
      panel: {
        paddingLeft: "2em",
        bg: "Primary.700",
        pb: "0.25em",
        pt: "0.25em",
      },
    },
    permissions: {
      allowToggle: true,
      container: {
        bg: "white",
        border: "0px",
        width: "100%",
        padding: "0em",
        borderRadius: "0.75em",
        boxShadow: "lg",
      },
      button: {
        padding: "0em",
        pl: "1em",
        pr: "1em",
        margin: "0em",
        _hover: {
          bg: "Primary.50",
          borderRadius: "0.5em",
        },
      },
      icon: {
        color: "Primary.500",
      },
      panel: {
        p: "0em",
        pl: "1em",
        pr: "1em",
        pb: "0.25em",
        mb: "0.5em",
      },
    },
  },
}

export default Accordions
